<template>
	<vs-list-item :title="resource_local.username" :subtitle="fullname">
		<template slot="avatar">
			<vs-avatar @click="openExportPopup" />
		</template>
		<wifi-icon size="24" color="#28c76f" class="mr-2"></wifi-icon>
		<battery-icon v-if="currentBatteryLevel >= 30" :color="batteryLevelIcon.color" class="mr-2"></battery-icon>
		<battery-charging-icon v-else :color="batteryLevelIcon.color" class="mr-2"></battery-charging-icon>
		<!-- <feather-icon
         size="24"
              :icon="batteryLevelIcon.icon"
              :svgClasses="'h-8 w-8 stroke-current ' + batteryLevelIcon.color"
            /> -->

		<vs-icon
			@click="openExportPopup"
			style="margin-top: -6px"
			:icon="gpsIcon"
			size="23px"
			:color="gpsIcon === 'gps_fixed' ? 'primary' : 'secondary'"
		></vs-icon>
	</vs-list-item>
</template>
<script>
import {BatteryChargingIcon, BatteryIcon, WifiIcon, NavigationIcon} from "vue-feather-icons";

export default {
	props: {
		resource: {
			type: Object,
		},
	},
	data: () => ({
		currentBatteryLevel: Math.floor(Math.random() * 100),
	}),
	computed: {
		resource_local() {
			return this.resource;
		},
		fullname() {
			return `${this.resource_local.name} ${this.resource_local.lastname}`;
		},
		gpsIcon() {
			return Math.floor(Math.random() * 2) === 1 ? "gps_fixed" : "gps_off";
		},
		batteryLevelIcon() {
			if (this.currentBatteryLevel >= 60) {
				return {icon: "BatteryIcon", color: "#28c76f"};
			} else if (this.currentBatteryLevel < 60 && this.currentBatteryLevel >= 30) {
				return {icon: "BatteryIcon", color: "#ff9f43"};
			} else {
				return {icon: "BatteryChargingIcon", color: "#ea5455"};
			}
		},
	},
	methods: {
		openExportPopup() {
			this.$emit("openExportPopupEmit");
		},
	},
	components: {
		BatteryChargingIcon,
		BatteryIcon,
		WifiIcon,
		NavigationIcon,
	},
};
</script>
